<template>
  <div class="out-room-item" @click="handleClick">
    <div class="out-room-container">
      <img class="icon" :src="itemData.icon" />

      <div class="out-name-container out-text-ellipsis">
        <div class="out-title-container">
          <!---->
          <div class="out-room-name out-text-ellipsis">
            {{ itemData.title }}
          </div>
          <!-- <div class="out-text-date">{{ itemData.pushTime }}</div> -->
        </div>
        <div class="out-text-last">
          <!---->
          <div class="out-format-message-wrapper out-text-ellipsis" v-html="itemData.content">
          </div>
          <!---->
          <div class="out-room-options-container">
            <div v-if="itemData.unreadNum > 0" class="out-room-dot">
              <!---->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
const emit = defineEmits(["click"]);
const props = defineProps({
  itemData: {
    type: Object,
    default: () => ({})
  }
});

console.log('itemData:', props.itemData);

const handleClick = () => {
  emit("click");
};
</script>
<style lang="scss" scoped>
.out-text-ellipsis {
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.out-room-item {
  min-height: 60px;
  padding: 0 8px;

  .out-room-container {
    display: flex;
    flex: 1;
    align-items: center;
    width: 100%;

    .icon {
      width: 42px;
      height: 42px;
      margin-right: 15px;
      display: block;
    }

    .out-name-container {
      flex: 1;
      padding: 17px 0;

      .out-title-container {
        display: flex;
        align-items: center;
        line-height: 25px;

        .out-room-name {
          flex: 1;
          color: #0a0a0a;
          font-weight: 500;
        }

        .out-text-date {
          margin-left: 5px;
          font-size: 11px;
          color: #a2aeb8;
        }
      }

      .out-text-last {
        display: flex;
        align-items: center;
        font-size: 12px;
        line-height: 19px;
        color: #67717a;

        :deep(b) {
            color: #ff3c3c;
          }

        .out-room-options-container {
          display: flex;
          margin-left: auto;
          .out-room-dot {
            width: 5px;
            height: 5px;
            min-width: 5px;

            background-color: #ff5656;
            color: #fff;
            margin-left: 5px;

            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 3px;
            font-size: 11px;
            font-weight: 500;
          }
        }
      }
    }
  }
}
</style>
